import styled from "styled-components";
import { spacing, sizing } from "@material-ui/system";

const Form = styled.form`
  ${spacing};
  ${sizing};
`;

export default Form;
